import {
  Table,
  TableRow,
  TableHeader,
  TableBody,
  TableHeaderCell,
  TableCell,
  IconTick,
  IconClear,
  Text,
  Stack,
  useSpace,
} from 'braid-design-system';
import { InlineCode } from 'scoobie';

import { TooltipHelpIcon } from '#src/components/TooltipHelpIcon/TooltipHelpIcon.tsx';

export const ApplicationCompleteSignalsTable = () => {
  const { grid } = useSpace();

  const minWidth = grid * 31;

  return (
    <Table label="Application complete signals" alignY="center">
      <TableHeader>
        <TableRow>
          <TableHeaderCell>
            <Text />
          </TableHeaderCell>
          <TableHeaderCell colspan={2}>
            <Text>If</Text>
          </TableHeaderCell>
          <TableHeaderCell colspan={4}>
            <Text>Then</Text>
          </TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableHeader>
        <TableRow>
          <TableHeaderCell>
            <Text />
          </TableHeaderCell>
          <TableHeaderCell>
            <Text>Candidate source</Text>
          </TableHeaderCell>
          <TableHeaderCell minWidth={minWidth} width="25%" wrap>
            <Text>Apply with SEEK used</Text>
          </TableHeaderCell>
          <TableHeaderCell minWidth={minWidth} width="25%" wrap>
            <Text>Send signal?</Text>
          </TableHeaderCell>
          <TableHeaderCell minWidth={minWidth} width="25%" wrap>
            <Text>Source attributed to SEEK?</Text>
          </TableHeaderCell>
          <TableHeaderCell minWidth={minWidth} width="25%" wrap>
            <Text>Application complete reflected in Ad Performance Panel?</Text>
          </TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        <TableRow>
          <TableCell>
            <Text>1</Text>
          </TableCell>
          <TableCell>
            <Text>SEEK</Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconTick tone="positive" />
            </Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconTick tone="positive" />
            </Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconTick tone="positive" />
            </Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconTick tone="positive" />
            </Text>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Text>2</Text>
          </TableCell>
          <TableCell>
            <Stack space="xsmall">
              <Text>SEEK</Text>
              <Text size="xsmall">
                with pre-authorization{' '}
                <TooltipHelpIcon
                  tooltip={
                    <>
                      Candidate arrives with pre-authorization, indicated by
                      receiving a{' '}
                      <InlineCode weight="weak">seek-prefill-id</InlineCode>
                    </>
                  }
                />
              </Text>
            </Stack>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconTick tone="positive" />{' '}
              <TooltipHelpIcon tooltip="Skip candidate authorization handling" />
            </Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconTick tone="positive" />
            </Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconTick tone="positive" />
            </Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconTick tone="positive" />
            </Text>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Text>3</Text>
          </TableCell>
          <TableCell>
            <Text>SEEK</Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconClear tone="critical" />
            </Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconTick tone="positive" />
            </Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconTick tone="positive" />
            </Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconTick tone="positive" />
            </Text>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Text>4</Text>
          </TableCell>
          <TableCell>
            <Stack space="xsmall">
              <Text>Other source</Text>
              <Text size="xsmall">with SEEK job ad</Text>
            </Stack>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconTick tone="positive" />
            </Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconTick tone="positive" />{' '}
              <TooltipHelpIcon tooltip="Used to track Apply with SEEK usage only" />
            </Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconClear tone="critical" />
            </Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconClear tone="critical" />
            </Text>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Text>5</Text>
          </TableCell>
          <TableCell>
            <Stack space="xsmall">
              <Text>Other source</Text>
              <Text size="xsmall">without SEEK job ad</Text>
            </Stack>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconTick tone="positive" />
            </Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconTick tone="positive" />{' '}
              <TooltipHelpIcon tooltip="Used to track Apply with SEEK usage only" />
            </Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconClear tone="critical" />
            </Text>
          </TableCell>
          <TableCell>
            <Text size="large">
              <IconClear tone="critical" />
            </Text>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
